export const FirebaseConfig = {
    apiKey: "AIzaSyBQVTWTB6iDBZYr2yMDb435QfivUFUR18M",
    authDomain: "showmego-7c72d.firebaseapp.com",
    databaseURL: "https://showmego-7c72d.firebaseio.com",
    projectId: "showmego-7c72d",
    storageBucket: "showmego-7c72d.appspot.com",
    messagingSenderId: "638022390983",
    appId: "1:638022390983:web:26bc5f9026fd78a15a5ae2",
    measurementId: "G-XZWHC7SVM7"
  };